{
  "acceptedFileFormats": ".docx, .pdf, .txt 파일만 허용됩니다.",
  "actionCompetenceGroup": "작업 역량 그룹",
  "actionDeadline": "작업 마감일",
  "actionDescription": "작업 설명",
  "actionDuration": "작업 기간",
  "actionEarliestStart": "작업 최조 시작일",
  "actionName": "작업 이름",
  "actions": "작업",
  "actionsAndProjects": "작업 및 프로젝트",
  "actionsColon": "작업: ",
  "actionsPerformerConstraints": "작업 수행자 제약",
  "add": "추가",
  "addAdmin": "관리자 추가",
  "addAdminTitle": "관리자 추가",
  "addAnalyses": "분석 추가",
  "addAnalysis": "분석 추가",
  "addAnalysisGroup": "분석 그룹 추가",
  "addChatbot": "챗봇 추가",
  "addCompetenceGroup": "역량 그룹 추가",
  "addConstraint": "제약 추가",
  "addGreyTask": "회색 작업 추가",
  "addInstrument": "장비 추가",
  "addItemPlaceholder": "{{item}} 추가...",
  "addLocation": "위치 추가",
  "addMaintenance": "유지보수 추가",
  "addMember": "멤버 추가",
  "addNewBundle": "새 번들 추가",
  "addNewMaintenanceFor": "{{assetName}}에 새 유지보수 추가",
  "addNewTask": "새 작업 추가",
  "addOffsite": "외부 근무 추가",
  "addProjectGroup": "프로젝트 그룹 추가",
  "addProjectTemplate": "프로젝트 템플릿 추가",
  "addRepository": "저장소 추가",
  "addRow": "행 추가",
  "addSample": "샘플 추가",
  "addSamples": "샘플 추가",
  "addTeam": "팀 추가",
  "additionalInformation": "추가 정보",
  "administrators": "관리자",
  "advanced": "고급",
  "allFilesProcessed": "업로드된 모든 파일이 처리되었습니다",
  "allowMembersMoveOthersOperationalTasks": "멤버가 다른 사람의 운영 작업을 이동할 수 있도록 허용",
  "allowedCompetenceGroups": "허용된 역량 그룹",
  "allowedInstruments": "허용된 장비",
  "amountOfSamples": "샘플 수: {{count}}",
  "analyses": "분석",
  "analysesRelatedTo": "{{product}}와 관련된 분석",
  "analysis": "분석",
  "analysisAndSampleDone": "분석 및 샘플이 완료되었습니다",
  "analysisDefinition": "분석 정의",
  "analysisDesignTool": "분석 설계 도구",
  "analysisDone": "분석이 완료되었습니다",
  "analysisDraft": "분석 초안",
  "analysisGroup": "분석 그룹",
  "analysisGroupName": "분석 그룹 이름",
  "analysisIsFlagged": "분석이 플래그됨",
  "analysisMustContainTaskDefinition": "분석에 작업 정의가 포함되어야 합니다",
  "analysisName": "분석 이름",
  "analysisNameMustBeUnique": "분석 이름은 고유해야 합니다",
  "analysisNotPlanned": "이 분석은 계획되지 않았습니다",
  "analysisPlanned": "분석이 계획되었습니다",
  "analysisTaskBundle": "분석 작업 번들 {{index}}",
  "cdmoTargetedBundle": "분석 이름별로 작업 묶기",
  "analysisTaskTimePerformerSamples": "분석 작업 - 시간, 수행자, 샘플 수",
  "analysisTasks": "분석 작업",
  "analysisTasksToBundle": "번들할 분석 작업",
  "analysisTimePercentage": "전체 시간 대비 분석 시간 비율 (A2T)",
  "anywhere": "어디서나",
  "apiToken": "API 토큰",
  "archiveMember": "멤버 보관",
  "archived": "보관됨",
  "areYouSureConnection": "이 연결을 유지하시겠습니까?",
  "areYouSureConnectionMode": "\"연결 포함\" 모드로 전환하시겠습니까? 현재 모든 연결이 삭제됩니다",
  "areYouSureDeleteAdmin": "이 관리자를 삭제하시겠습니까?",
  "areYouSureDiscardSimulation": "시뮬레이션 모드에서 변경된 내용을 취소하시겠습니까?",
  "areYouSurePublishSimulation": "시뮬레이션 모드에서 변경된 내용을 게시하시겠습니까?",
  "areYouSureReset": "재설정하시겠습니까? 모든 노드가 삭제됩니다.",
  "areYouSureUnplanAllFutureActions": "이 프로젝트의 모든 미래 작업을 미계획으로 전환하시겠습니까?",
  "areYouSureWantToExit": "종료하시겠습니까?",
  "arrival": "도착",
  "assetAddedOrRemoved": "자산이 추가되거나 제거되었습니다",
  "assetRequirementsForAsset": "자산 {{index}}의 요구사항",
  "assets": "자산",
  "atLeast1LowercaseLetter": "소문자 1자 이상",
  "atLeast1Number": "숫자 1자 이상",
  "atLeast1UppercaseLetter": "대문자 1자 이상",
  "atLeast8Characters": "8자 이상",
  "automaticImportConversionSheet": "자동 {{type}} 가져오기 변환 시트",
  "automaticSheetConfiguration": "자동 시트 구성",
  "availability": "가용성",
  "availableTimeOneWeek": "1주일 가용 시간: ",
  "avgAnalysisDuration": "평균 분석 기간: ",
  "avgSampleBatchInterval": "평균 샘플 배치 간격: ",
  "avgSamplesAllocated": "평균 할당된 샘플 수: ",
  "backlog": "백로그",
  "booked": "예약됨",
  "bookedBy": "예약자",
  "byCompetenceGroup": "역량 그룹별",
  "byDeadline": "마감일별",
  "byGroup": "그룹별",
  "byText": "텍스트별",
  "canBePerformedAnywhere": "어디서나 수행 가능",
  "canOnlyBePerformedOnSite": "현장에서만 수행 가능",
  "cancel": "취소",
  "cancelChanges": "변경 취소",
  "cannotUnlockStartedTasks": "하나 이상의 작업이 시작/일시정지/완료 상태이므로 잠금 해제할 수 없습니다",
  "changeLogs": "변경 로그",
  "changesHaveBeenMade": "변경사항이 있습니다. 새 데이터를 보려면 새로고침하세요",
  "chatbotGreeting": "안녕하세요! 저는 Plannertech 및 Librarian 도움말 문서와 가져온 데이터 저장소를 전문으로 하는 AI 챗봇입니다.\npt@arnvind.com (CET 9-16시)으로 인간 지원팀에 문의하실 수도 있습니다.\n어떻게 도와드릴까요? :-)",
  "chatbotName": "챗봇 이름",
  "chatbotPlaceholder": "챗봇이 어떻게 동작해야 하는지 간단히 설명을 작성하세요.",
  "chatbots": "챗봇",
  "chattingWith": "{{name}}과 대화 중",
  "chooseAction": "작업 선택",
  "chooseTask": "작업 선택",
  "chooseWhatToAdd": "추가할 항목 선택",
  "cleanUp": "정리",
  "clear": "지우기",
  "clearConversation": "대화 지우기",
  "clearDates": "날짜 지우기",
  "clearTable": "테이블 지우기",
  "clickToSelectOtherFiles": "다른 파일을 선택하려면 클릭하세요",
  "close": "닫기",
  "closeMessage": "메시지 닫기",
  "closePanel": "패널 닫기",
  "collaborator": "협력자",
  "collaborators": "협력자",
  "domain": "도메인",
  "color": "색상",
  "columnName": "열 이름",
  "companyWideChatbot": "전사 챗봇",
  "competenceAndInstrumentConstraints": "역량 및 장비 제약",
  "competenceGroup": "역량 그룹",
  "competenceGroupNameExists": "해당 이름의 역량 그룹이 이미 존재합니다",
  "competenceGroups": "역량 그룹",
  "competenceGroupsColon": "역량 그룹: ",
  "configuration": "구성",
  "confirm": "확인",
  "confirmArchivalOfMember": "멤버 보관 확인: {{initials}}",
  "confirmClearTable": "테이블을 지우시겠습니까?",
  "confirmDeleteAllData": "확인 시 모든 {{type}} 데이터가 삭제됩니다. 시뮬레이션 모드에서도 되돌릴 수 없습니다.",
  "confirmDeleteAllUnplannedProjects": "확인 시 계획에 배치된 작업이 없는 모든 프로젝트가 삭제됩니다",
  "confirmDeleteAllUnplannedSamples": "확인 시 계획에 배치된 작업이 없는 모든 샘플이 삭제됩니다",
  "confirmDeleteCompetenceGroup": "역량 그룹 삭제 확인:",
  "confirmDeleteInstrument": "장비 {{name}}을(를) 삭제하시겠습니까?",
  "confirmDeleteMaintenance": "이 유지보수를 삭제하시겠습니까?",
  "confirmDeleteSample": "이 미계획 샘플을 삭제하시겠습니까?",
  "confirmDeleteSampleInfo": "확인 시 선택한 샘플이 영구적으로 삭제됩니다",
  "confirmDeletion": "삭제 확인",
  "confirmFailSamples": "선택한 샘플을 실패 처리하시겠습니까?",
  "confirmFailSamplesInfo": "확인 시 선택한 샘플이 실패 처리됩니다. 복사본이 미계획 분석 메뉴에 배치됩니다",
  "confirmFailSamplesQuestion": "선택한 샘플을 실패 처리하시겠습니까?",
  "confirmShowPlannedSamplesInfo": "확인 시 계획된 샘플이 표시됩니다",
  "confirmShowPlannedSamplesQuestion": "계획된 샘플을 표시하시겠습니까?",
  "confirmSortByTime": "시간별로 정렬하시겠습니까",
  "confirmUnplanAllFutureActions": "이 프로젝트의 모든 미래 작업을 미계획으로 전환하시겠습니까?",
  "confirmUnplanAllQuestion": "모든 {{itemType}}을(를) 미계획으로 전환하시겠습니까?",
  "confirmUnplanSamplesInfo": "확인 시 선택한 샘플이 미계획으로 전환됩니다. 미계획 분석 메뉴에 배치됩니다",
  "confirmUnplanSamplesQuestion": "선택한 샘플을 미계획으로 전환하시겠습니까?",
  "connectionCalculatedInWorkdays": "연결이 작업일 단위로 계산됨",
  "connectionCount": "연결 수",
  "connections": "연결",
  "connectionsAdvancedWarning": "(작업에 마감일 또는 최조 시작일과 함께 연결을 사용하는 것은 고급 사용자를 위한 것입니다)",
  "connectionsPerformersOnly": "연결은 수행자 전용입니다 - 자산 할당에 영향을 주지 않습니다",
  "contactArnvindSupport": "pt@arnvind.com으로 Arnvind 지원팀에 문의하세요",
  "conversionSheet": "변환 시트",
  "copyToClipboard": "클립보드에 복사",
  "country": "국가",
  "create": "생성",
  "createANewColumn": "새 열 만들기",
  "createAction": "작업 만들기",
  "createChatbot": "챗봇 만들기",
  "createEditChatbots": "챗봇 만들기/편집",
  "createEditRepositories": "저장소 만들기/편집",
  "createNewColumn": "새 열 만들기",
  "createNewProject": "새 프로젝트 만들기",
  "createSingleAction": "단일 작업 만들기",
  "createStage": "단계 만들기",
  "createStandardAction": "표준 작업 만들기",
  "currentlyProcessingRepository": "현재 이 저장소를 처리 중입니다",
  "daily": "매일",
  "date": "날짜",
  "dateUnavailable": "날짜 사용 불가",
  "day": "일",
  "dayS": "일",
  "days": "일",
  "daysBeforeExpirationWarning": "만료 전 경고 표시 일수",
  "daysBetweenRecurrences": "반복 간격 (일)",
  "deadline": "마감일",
  "deadlineColon": "마감일: ",
  "deadlineDate": "마감 날짜",
  "deadlineMustBeLaterThanEarliestStart": "마감일은 최조 시작일보다 늦거나 같아야 합니다",
  "deadlineTime": "마감 시간",
  "defaultChatbot": "기본 챗봇",
  "delete": "삭제",
  "deleteAllTypeTestData": "모든 {{type}} 테스트 데이터 삭제",
  "deleteAllUnplannedProjects": "모든 미계획 프로젝트 삭제",
  "deleteAllUnplannedSamples": "모든 미계획 샘플 삭제",
  "deleteColumn": "열 삭제",
  "deleteCompetenceGroup": "역량 그룹 삭제",
  "deleteCompetenceGroupWarning": "삭제 시 다음 분석의 작업에 역량 그룹이 없게 됩니다. 삭제 전에 대체 그룹을 지정하세요.",
  "deleteConstraint": "제약 삭제",
  "deleteData": "데이터 삭제",
  "deleteInstrument": "장비 삭제",
  "deleteInstrumentWarning": "이 위치의 다른 팀에서도 삭제됩니다.",
  "deleteProjects": "프로젝트 삭제",
  "deleteSample": "샘플 삭제",
  "deleteSamples": "샘플 삭제",
  "deleteThisRow": "이 행 삭제",
  "description": "설명",
  "designTool": "설계 도구",
  "done": "완료",
  "draft": "초안",
  "dragAndDropFiles": "파일을 여기에 드래그 앤 드롭하거나 클릭하여 파일을 선택하세요",
  "dragAndDropFolders": "폴더를 여기에 드래그 앤 드롭하거나 클릭하여 특정 파일을 선택하세요",
  "dropFilesHere": "여기에 파일을 놓으세요",
  "dropFoldersHere": "폴더를 여기에 놓으세요...",
  "duplicate": "복제",
  "durationHHMM": "기간 (HH:MM)",
  "earliestStart": "최조 시작",
  "edit": "편집",
  "editAction": "작업 편집",
  "editAdmin": "관리자 편집",
  "editAnalysisGroup": "분석 그룹 편집",
  "editAnalysisTask": "분석 작업 편집",
  "editChatbot": "챗봇 편집",
  "editCompetenceGroup": "역량 그룹 편집",
  "editConnectionFromTo": "{{from}}에서 {{to}}로의 연결 편집",
  "editConversation": "대화 편집",
  "editGroup": "그룹 편집",
  "editInstrument": "장비 편집",
  "editItem": "{{item}} 편집",
  "editLocationName": "위치 이름 편집",
  "editMaintenanceFor": "{{assetName}}의 {{name}} 편집",
  "editMember": "멤버 편집",
  "editOffsite": "외부 근무 편집",
  "editProject": "프로젝트 편집",
  "editProjectGroup": "프로젝트 그룹 편집",
  "editProjectTemplate": "프로젝트 템플릿 편집",
  "editProjectTemplateDraft": "프로젝트 템플릿 초안 편집",
  "editRepository": "저장소 편집",
  "editSampleName": "샘플 편집: {{name}}",
  "editSheet": "시트 편집: {{name}}",
  "editStandardAction": "표준 작업 편집",
  "editTask": "작업 편집",
  "editTeam": "팀 편집",
  "edited": "편집됨",
  "email": "이메일",
  "emailCannotContainDoubleDots": "이메일에 '..'가 포함될 수 없습니다",
  "emailLabel": "이메일",
  "endDate": "종료 날짜",
  "enterSimulationMode": "시뮬레이션 모드 진입",
  "errors": "오류",
  "errorsProcessingRepository": "이 저장소를 처리하는 중 오류가 발생했습니다",
  "estimatedWorkloadOneWeek": "1주일 예상 작업량: ",
  "exclusive": "전용",
  "exclusiveSampleIndicator": "* 전용 샘플을 나타냅니다",
  "exitSimulation": "시뮬레이션 종료",
  "exitSimulationMode": "시뮬레이션 모드 종료",
  "expand": "확장",
  "exportToExcel": "엑셀로 내보내기",
  "fail": "실패",
  "failSample": "샘플 실패",
  "failSelected": "선택 항목 실패",
  "failedLoading": "로딩 실패: {{members}}",
  "failedToCreateMaintenance": "유지보수 \"{{name}}\" 생성 실패",
  "failedToDeleteMaintenance": "유지보수 \"{{name}}\" 삭제 실패",
  "failedToMarkMaintenanceAsCompleted": "유지보수 \"{{name}}\"을(를) 완료로 표시 실패",
  "failedToUpdateMaintenance": "유지보수 \"{{name}}\" 업데이트 실패",
  "failedUploads": "업로드 실패",
  "fileUpload": "파일 업로드",
  "fileUploadError": "파일 업로드 중 오류가 발생했습니다",
  "filenameLabel": "파일 이름: ",
  "filesUploadedSuccessfully": "파일이 성공적으로 업로드되었습니다",
  "fillIn": "채우기",
  "fillInIgnoreOverbooking": "초과 예약 무시하고 채우기",
  "filter": "필터",
  "filterByName": "이름으로 필터",
  "filterBySampleName": "샘플 이름으로 필터",
  "filterBySampleProductName": "샘플/제품 이름으로 필터",
  "filterByText": "텍스트로 필터",
  "finished": "완료됨",
  "flag": "플래그",
  "flagSample": "샘플 플래그",
  "followingErrorsWhileImporting": "가져오는 중 다음 오류가 발생했습니다:",
  "free": "여유",
  "from": "시작",
  "fromDate": "시작 날짜",
  "fromTime": "시작 시간 (HH:MM)",
  "fromTimeHH": "시작 시간 (HH)",
  "fromTimeHHMM": "시작 시간 (HH:MM)",
  "futureAnalysisTaskCantBe": "미래 분석 작업은 {{state}} 상태가 될 수 없습니다",
  "generate": "생성",
  "globalChatbot": "글로벌 챗봇",
  "goBack": "뒤로",
  "goBackToChat": "채팅으로 돌아가기",
  "greyTaskTimePercentage": "전체 시간 대비 회색 작업 시간 비율 (G2T)",
  "groupMembers": "그룹 멤버",
  "groupName": "그룹 이름",
  "help": "도움말",
  "helpBackToApp": "앱으로 돌아가기",
  "helpHome": "도움말 홈",
  "helpPageNotFound": "도움말 페이지를 찾을 수 없습니다",
  "helpSearch": "도움말 검색",
  "helpAppTitle": "Plannertech 도움말",
  "hidden": "숨김",
  "hideMore": "더 숨기기",
  "highestPriority": "1이 가장 높은 우선순위",
  "history": "기록",
  "home": "홈",
  "hour": "시간",
  "iCalendarOutlookIntegration": "iCalendar / Outlook 통합",
  "iap": "IAP",
  "ignoreAllGreytasks": "모든 회색 작업 무시",
  "ignoredByIap": "IAP에서 무시됨",
  "includingToday": "오늘 포함",
  "importedTask": "가져온 작업",
  "busyOnAnotherTeam": "다른 팀에서 바쁨",
  "includeDoneSamples": "완료된 샘플 포함",
  "includeOverdue": "기한 초과 포함",
  "includeToday": "오늘 포함",
  "iapIncludeTodayWarningIAP": "경고: IAP와 오늘 포함 - 오늘 이전에 계획된 작업도 잠기지 않으면 이동될 수 있습니다!",
  "iapIncludeTodayWarningFillIn": "경고: 채우기와 오늘 포함 - 오늘 이전에 계획된 작업에도 새 샘플이 할당될 수 있습니다!",
  "initials": "이니셜",
  "inputLastMonth": "지난 달 입력",
  "inputThisMonth": "이번 달 입력",
  "instrument": "장비",
  "instrumentConstraints": "장비 제약",
  "instrumentLog": "장비 로그",
  "instrumentName": "장비 이름",
  "instrumentOffset": "장비 오프셋 (HH:MM)",
  "instrumentOverbooking": "장비 초과 예약",
  "instrumentPerSampleDuration": "샘플당 장비 기간 (HH:MM:SS)",
  "instrumentSetup": "장비 설정: {{name}}",
  "instrumentSetuptime": "장비 설정 시간 (HH:MM)",
  "instrumentTime": "장비 시간",
  "instrumentView": "장비 보기",
  "instruments": "장비",
  "instrumentsWithExpiredMaintenance": "유지보수가 만료된 장비가 있습니다",
  "instrumentsWithMaintenanceReminders": "유지보수 알림이 있는 장비가 있습니다",
  "integration": "통합",
  "invalidDate": "유효하지 않은 날짜",
  "invalidOutlookLink": "유효하지 않은 iCalendar / Outlook 링크",
  "isInSimulationMode": "{{initials}} 시뮬레이션 모드 중",
  "isSimulating": "{{initials}} 시뮬레이션 중...",
  "keepExistingConnections": "기존 연결 유지",
  "labelAlreadyLoaded": "이미 로드됨: {{count}}",
  "labelCreated": "생성됨: {{count}}",
  "labelDeleted": "삭제됨: {{count}}",
  "labelDeletedOrFinished": "삭제 또는 완료로 표시됨: {{count}}",
  "labelDoneDeleted": "완료/삭제됨: {{count}}",
  "labelUpdatedInformation": "업데이트된 정보: {{count}}",
  "lastErrorLog": "최근 오류 로그",
  "lastWeek": "지난 주",
  "latestArrival": "최대 도착 시간",
  "leadTimesInWorkDays": "작업일 단위 리드 타임",
  "leaveEmptyIfNotUsed": "(사용하지 않으면 비워두세요)",
  "leaveEmptyIfNotUsedDefault": "(사용하지 않으면 비워두세요, 기본값={{defaultValue}})",
  "loadFromTemplate": "템플릿에서 불러오기",
  "loading": "로딩 중",
  "loadingEllipsis": "로딩 중...",
  "loadingSamples": "샘플 로딩 중",
  "loadingSheet": "시트 로딩 중",
  "loadingSheets": "시트들 로딩 중",
  "location": "위치",
  "locationColon": "위치: {{name}}",
  "locationName": "위치 이름",
  "lockItemType": "{{itemType}} 잠금",
  "lockSamples": "샘플 잠금",
  "lockUnlockSamplesLabel": "샘플 잠금/잠금 해제:",
  "locks": "잠금",
  "locksAllFutureAnalysisTasks": "미래에 계획된 모든 분석 작업 잠금",
  "locksAllFutureProjectActions": "미래에 계획된 모든 프로젝트 작업 잠금",
  "login": "로그인",
  "logout": "로그아웃",
  "maintenanceCreatedSuccessfully": "유지보수 \"{{name}}\"이(가) 성공적으로 생성되었습니다",
  "maintenanceDeletedSuccessfully": "유지보수 \"{{name}}\"이(가) 성공적으로 삭제되었습니다",
  "maintenanceExpired": "유지보수 만료됨",
  "maintenanceExpiresInDays": "유지보수가 {{days}}일 이내에 만료됩니다",
  "maintenanceMarkedAsCompleted": "유지보수 \"{{name}}\"이(가) 완료로 표시되었습니다",
  "maintenanceName": "유지보수 이름",
  "maintenanceUpdatedSuccessfully": "유지보수 \"{{name}}\"이(가) 성공적으로 업데이트되었습니다",
  "mandatoryIfRecurrenceUsed": "(반복 사용 시 필수)",
  "manualSample": "수동 샘플",
  "manualSheetConfiguration": "수동 시트 구성",
  "markAsDone": "완료로 표시",
  "maxSampleCount": "최대 샘플 수",
  "maxSampleCountLabel": "최대 샘플 수: ",
  "maxTimeBetweenActions": "작업 간 최대 시간 (DD:HH:MM)",
  "maxTimeBetweenTasks": "작업 간 최대 시간 (DD:HH:MM)",
  "member": "멤버",
  "memberHasEnabledICalendarOutlookIntegration": "멤버가 iCalendar / Outlook 통합을 활성화했습니다",
  "memberHasEnabledOutlook": "멤버가 iCalendar / Outlook 통합을 활성화했습니다",
  "memberPermissions": "멤버 권한",
  "memberPlan": "멤버 계획",
  "memberTime": "멤버 시간",
  "membersGoDirectlyToMemberPlan": "멤버가 멤버 계획으로 바로 이동",
  "message": "메시지",
  "metric": "지표",
  "minSampleCount": "최소 샘플 수",
  "minSampleMustBeLowerThanMax": "최소 샘플 수는 최대 샘플 수보다 작아야 합니다",
  "minTimeBetweenActions": "작업 간 최소 시간 (DD:HH:MM)",
  "minTimeBetweenTasks": "작업 간 최소 시간 (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "최소 시간은 최대 시간보다 작아야 합니다",
  "minimumDuration": "최소 기간: {{time}}",
  "minute": "분",
  "missingPasswordRequirements": "비밀번호 요구사항 미충족: {{requirements}}",
  "months": "개월",
  "movedBy": "이동자",
  "movedFrom": "이동 출발지",
  "movedTo": "이동 목적지",
  "mustBeIcsLink": ".ics 링크여야 합니다",
  "name": "이름",
  "namePerformer": "{{name}} 수행자",
  "nameTooLongTitle": "이름이 너무 깁니다 (최대 100자)",
  "newAnalysisTaskBundle": "새 분석 작업 번들",
  "newChat": "새 채팅",
  "newInstrument": "새 장비",
  "newProject": "새 프로젝트",
  "newProjectTemplateDraft": "새 프로젝트 템플릿 초안",
  "newStart": "새 시작",
  "nextDay": "다음 날",
  "nextWeek": "다음 주",
  "no": "아니오",
  "noAnalysesForProduct": "이 제품에 대한 분석이 없습니다.",
  "noAssetsFound": "자산을 찾을 수 없습니다",
  "noChanges": "변경사항 없음",
  "noChatbotSelected": "챗봇이 선택되지 않았습니다",
  "noDataFound": "데이터를 찾을 수 없습니다",
  "noErrorsToDisplay": "표시할 오류가 없습니다.",
  "noGroup": "그룹 없음",
  "noMembersLoaded": "로드된 멤버가 없습니다.",
  "noOfRecurrences": "반복 횟수",
  "noReferencesAvailable": "사용 가능한 참조가 없습니다.",
  "noSamples": "샘플 없음",
  "noSamplesAvailable": "사용 가능한 샘플이 없습니다",
  "noSearchResults": "검색 결과 없음",
  "noTimeLimitUnlessSpecified": "지정하지 않으면 시간 제한 없음",
  "none": "없음",
  "default": "기본값",
  "notAvailable": "해당 없음",
  "notEnoughRoomForDuration": "기간에 대한 공간이 충분하지 않습니다",
  "notStarted": "시작되지 않음",
  "numberOfObservations": "관찰 수",
  "numberOfRecurrences": "반복 횟수",
  "numericInputBetweenTimeRange": "00:00에서 23:59 사이의 숫자를 입력하세요",
  "offsiteCalendar": "외부 근무 캘린더",
  "ok": "확인",
  "oldInstrument": "이전 장비",
  "oldStart": "이전 시작",
  "onlyAdvancedUsersInfo": "최조 시작과 연결을 모두 사용하는 것은 고급 사용자만을 위한 것입니다",
  "onsite": "현장",
  "openReferences": "참조 열기",
  "operationalGreyTaskTimePercentage": "전체 시간 대비 운영 회색 작업 시간 비율 (OG2T)",
  "operationalTask": "운영 작업",
  "otherPlannerSimulating": "{{initials}} 시뮬레이션 모드 중",
  "outlookLinkLabel": "iCalendar / Outlook 링크",
  "outputLastMonth": "지난 달 출력",
  "outputThisMonth": "이번 달 출력",
  "parentColumn": "상위 열",
  "password": "비밀번호",
  "paused": "일시정지됨",
  "peopleSetup": "인원 설정",
  "perSampleDuration": "샘플당 기간 (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "인원 설정을 위한 샘플당 기간",
  "performerConstraintsCount": "수행자 제약 수",
  "performerConstraintsLabel": "수행자 제약",
  "permanentApiToken": "영구 API 토큰",
  "permanentApiTokenDescription": "팀에 API를 통해 접근할 수 있는 영구 API 토큰입니다. 복사하여 안전한 장소에 저장하세요.",
  "pinConversation": "대화 고정",
  "planned": "계획됨",
  "planner": "플래너",
  "plannertechLanguage": "Plannertech 언어",
  "plannertechVariable": "Plannertech 변수",
  "pleaseChooseColor": "분석에 색상을 선택하세요",
  "pleaseFillOutAnalysisName": "분석 이름을 입력하세요",
  "pleaseFillOutRequiredTaskParams": "필수 작업 매개변수를 입력하세요",
  "pleaseGiveEmptyOrFullInput": "비어있거나 완전한 입력을 제공하세요",
  "pleaseGiveNumericInput": "숫자 입력을 제공하세요",
  "pleaseInputValidDate": "유효한 날짜를 입력하세요",
  "pleaseSelectAtLeastOneItem": "최소 하나의 항목을 선택하세요",
  "pleaseSelectColor": "색상을 선택하세요",
  "pleaseSelectFirstDay": "첫 번째 날을 선택하세요.",
  "pleaseSelectLastDay": "마지막 날을 선택하세요.",
  "pleaseSelectTimezone": "시간대를 선택하세요",
  "previousDay": "이전 날",
  "primary": "기본",
  "primaryInstrument": "기본 장비",
  "prioritizeByDeadline": "마감일별 IAP 우선순위",
  "prioritizeByPriority": "우선순위 번호별 IAP 우선순위",
  "priority": "우선순위",
  "priorityHigh": "(높음)",
  "priorityLow": "(낮음)",
  "priorityMedium": "(중간)",
  "process": "처리",
  "processed": "처리됨",
  "processing": "처리 중...",
  "processingInProgress": "처리 중",
  "productName": "제품 이름",
  "project": "프로젝트",
  "projectActions": "프로젝트 작업",
  "projectBatchNumber": "프로젝트 배치 번호",
  "projectDeadline": "프로젝트 마감일",
  "projectDescription": "프로젝트 설명",
  "projectEarliestStart": "프로젝트 최조 시작",
  "projectGroup": "프로젝트 그룹",
  "projectGroupName": "프로젝트 그룹 이름",
  "projectImport": "프로젝트 가져오기",
  "projectImportVariable": "프로젝트 가져오기 변수",
  "projectMaterialDescription": "프로젝트 자재 설명",
  "projectMaterialNumber": "프로젝트 자재 번호",
  "projectName": "프로젝트 이름",
  "projectPriority": "프로젝트 우선순위",
  "projectReleaseDate": "프로젝트 출시일",
  "projectSupplierName": "프로젝트 공급업체 이름",
  "projectSupplierNumber": "프로젝트 공급업체 번호",
  "projectTemplate": "프로젝트 템플릿",
  "projectTemplates": "프로젝트 템플릿",
  "projectTimePercentage": "전체 시간 대비 프로젝트 시간 비율 (P2T)",
  "projectView": "프로젝트 보기",
  "projects": "프로젝트",
  "projectsAndActions": "프로젝트 및 작업",
  "promptPrefix": "프롬프트 접두사",
  "promptTooLongTitle": "프롬프트가 너무 깁니다 (최대 1200자)",
  "publish": "게시",
  "publishSimulationChanges": "시뮬레이션 모드 변경사항 게시",
  "qcLibrarian": "QC 라이브러리안",
  "qcLibrarianTitle": "QC 라이브러리안 3.8",
  "recur": "반복",
  "recurEvery": "매 반복",
  "recurrence": "반복",
  "reduce": "축소",
  "references": "참조",
  "rejectedFileTypes": "거부된 파일 형식",
  "rejectedFilesIncompatible": "다음 파일은 호환되지 않는 형식으로 인해 거부되었습니다",
  "reminderDaysBeforeEndDate": "알림 (종료일 전 일수)",
  "remove": "제거",
  "removeAnalysisFromProduct": "이 제품에서 {{name}} 제거",
  "removeAsset": "자산 제거",
  "removeEverything": "모두 제거",
  "removeInstrument": "장비 제거",
  "reportGenerator": "보고서 생성기",
  "reports": "보고서",
  "repositories": "저장소",
  "repositoryCurrentlyProcessing": "저장소가 현재 파일을 처리 중입니다. 진행 상황을 보려면 페이지를 새로고침하세요",
  "repositoryHasUnprocessedFiles": "이 저장소에 처리되지 않은 파일이 있습니다",
  "repositoryIsProcessed": "이 저장소는 처리되었습니다",
  "repositoryName": "저장소 이름",
  "reset": "재설정",
  "role": "역할",
  "row": "행",
  "rowNumber": " 행 {{row}}",
  "runIAP": "IAP 실행",
  "runningIAP": "IAP 실행 중",
  "sampleAnalysisName": "샘플 분석 이름",
  "sampleBatchNumber": "샘플 배치 번호",
  "sampleHighestPriority": "이 샘플은 최고 우선순위입니다",
  "sampleId": "샘플 ID",
  "sampleIdWithValue": "샘플 ID: {{id}}",
  "sampleImport": "샘플 가져오기",
  "sampleImportVariable": "샘플 가져오기 변수",
  "sampleInProgressOnDoneAnalysis": "완료된 분석에서 진행 중인 샘플",
  "sampleIsDone": "샘플이 완료되었습니다",
  "sampleLog": "샘플 로그",
  "sampleLowestPriority": "이 샘플은 최저 우선순위입니다",
  "sampleMaterialNumber": "샘플 자재 번호",
  "sampleName": "샘플 이름",
  "sampleObservation": "샘플 관찰",
  "sampleObservations": "샘플 관찰",
  "samplePercentage": "샘플 비율",
  "sampleProductDescription": "샘플 제품 설명",
  "sampleReceivedDate": "샘플 수령 날짜",
  "sampleStatus": "샘플 상태",
  "sampleView": "샘플 보기",
  "samples": "샘플",
  "samplesWithName": "이름이 {{name}}인 샘플",
  "samplesWithoutProduct": "제품 없는 샘플",
  "save": "저장",
  "saveAs": "다른 이름으로 저장",
  "saveAsDraft": "{{type}} 초안으로 저장",
  "saveAsNew": "새로 저장",
  "saveAsNewAnalysis": "새 분석으로 저장",
  "saveAsNewTemplate": "새 템플릿으로 저장",
  "saveAsType": "{{type}}로 저장",
  "scrollToTop": "맨 위로 스크롤",
  "scrumView": "스크럼 보기",
  "scrumViewOrdering": "스크럼 보기 순서",
  "searchBySampleName": "샘플 이름으로 검색...",
  "searchCountry": "국가 검색",
  "seats": "좌석",
  "second": "초",
  "secondaryInstrumentMustHaveAllowedInstrument": "보조 장비 설정에는 최소 하나의 허용된 장비가 있어야 합니다",
  "selectAll": "모두 선택",
  "selectChatbot": "챗봇 선택",
  "selectDefaultChatbot": "기본 챗봇 선택",
  "selectEntireDay": "전체 날 선택",
  "selectEntireWorkday": "전체 근무일 선택",
  "selectLocation": "위치 선택...",
  "selectSamples": "샘플 선택",
  "selectState": "상태 선택...",
  "selectTimezone": "시간대 선택...",
  "selectType": "유형 선택",
  "selectedFilesReadyForSubmit": "제출 준비된 선택 파일/폴더:",
  "selectedProduct": "선택된 제품",
  "setPlannedValues": "계획 값 설정",
  "settings": "설정",
  "settingsForQcLibrarian": "QC 라이브러리안 설정",
  "setupTimeForPeopleSetup": "인원 설정을 위한 설정 시간",
  "setuptime": "설정 시간 (HH:MM)",
  "sheetName": "시트 이름",
  "sheetNameLabel": "시트 이름",
  "sheetType": "시트 유형",
  "shouldBeEqualTo": "같아야 합니다",
  "shouldNotBeEqualTo": "같지 않아야 합니다",
  "showAnalyses": "분석 표시",
  "showErrors": "오류 표시",
  "showLastErrorLog": "최근 오류 로그 표시",
  "showLibrarian": "라이브러리안 표시",
  "showLog": "로그 표시",
  "showMore": "더 보기",
  "showOnPlan": "계획에 표시",
  "showProjects": "프로젝트 표시",
  "shown": "표시",
  "simulationMode": "시뮬레이션 모드",
  "simulationModeLogoutWarning": "현재 시뮬레이션 모드입니다. 로그아웃하면 변경사항이 취소됩니다!",
  "simulationModeOccupied": "시뮬레이션 모드 사용 중",
  "simulationModeUpper": "시뮬레이션 모드",
  "somethingWentWrong": "오류가 발생했습니다",
  "sortByProduct": "제품별 정렬",
  "sortByTime": "시간별 정렬",
  "sortByTimeDescription": "백로그 및 할 일 작업은 마감일 순으로, 계획됨 및 완료됨은 시작 시간 순으로 정렬합니다",
  "speechToTextLanguage": "음성 인식 언어",
  "spreadsheetColumnName": "스프레드시트 열 이름",
  "stage": "단계",
  "standardActions": "표준 작업",
  "start": "시작",
  "startDate": "시작 날짜",
  "startDateCheckboxInfo": "체크 시 프로젝트 마감일, 작업 마감일 및 작업 시작이 프로젝트 시작에 상대적으로 이동합니다",
  "startEndDate": "시작/종료 날짜",
  "startProcessingInfo": "저장소 처리를 시작합니다. 저장소 크기에 따라 시간이 걸릴 수 있습니다",
  "startRecurrence": "반복 시작",
  "startTime": "시작 시간",
  "started": "시작됨",
  "state": "상태",
  "status": "상태",
  "submit": "제출",
  "successfullyLoaded": "성공적으로 로드됨: {{members}}",
  "successfullyUploadedFiles": "성공적으로 업로드된 파일",
  "systemPrompt": "시스템 프롬프트",
  "taskBelongsToTeam": "작업이 속한 팀: {{team}}",
  "taskCount": "작업 수",
  "taskDesignTool": "작업 설계 도구",
  "taskLog": "작업 로그",
  "taskName": "작업 이름",
  "taskPerformerConstraints": "작업 수행자 제약",
  "tasks": "작업",
  "team": "팀",
  "teamChatbot": "팀 챗봇",
  "teamLabel": "팀: {{name}}",
  "teamMember": "팀 멤버",
  "teamName": "팀 이름",
  "teamPlan": "팀 계획",
  "teamUsageTitle": "{{name}} 사용량",
  "teams": "팀",
  "templateIsDraft": "이 프로젝트 템플릿은 초안입니다",
  "templateName": "템플릿 이름",
  "theProjectIsDone": "프로젝트가 완료되었습니다",
  "timeConstraints": "시간 제약",
  "timeHHMM": "시간 (HH:MM)",
  "timePeriod": "기간",
  "timestamp": "타임스탬프",
  "timezone": "시간대",
  "to": "종료",
  "toConfirmDeletionType": "삭제 확인을 위해 {{keyword}}를 입력하세요",
  "toConfirmDeletionTypeDeleteData": "삭제 확인을 위해 {{keyword}}를 입력하고 확인을 누르세요. 시뮬레이션 모드에서도 테스트 데이터가 영구적으로 삭제됩니다. 되돌릴 수 없습니다.",
  "toConfirmDeletionTypeKeyword": "삭제 확인을 위해 {{keyword}}를 입력하고 확인을 누르세요",
  "toDate": "종료 날짜",
  "toDo": "할 일",
  "toTime": "종료 시간 (HH:MM)",
  "toTimeHH": "종료 시간 (HH)",
  "toTimeHHMM": "종료 시간 (HH:MM)",
  "today": "오늘",
  "tokens": "토큰",
  "total": "합계",
  "normalSeats": "일반",
  "tryReloadingOrContactSupport": "새로고침을 시도하거나 문제가 지속되면 지원팀에 문의하세요!",
  "type": "유형",
  "typeBeforeConfirming": "확인 전에 {{keyword}}를 입력하세요",
  "typeOrSelect": "입력 또는 선택...",
  "typeYourMessage": "메시지를 입력하세요...",
  "unassignedSamples": "미배정 샘플",
  "unassignedSamplesFor": "\"{{name}}\"의 미배정 샘플",
  "unflag": "플래그 해제",
  "unflagSample": "샘플 플래그 해제",
  "unlockItemType": "{{itemType}} 잠금 해제",
  "unlockSamples": "샘플 잠금 해제",
  "unlocks": "잠금 해제",
  "unlocksAllFutureAnalysisTasks": "미래에 계획된 모든 분석 작업 잠금 해제",
  "unlocksAllFutureProjectActions": "미래에 계획된 모든 프로젝트 작업 잠금 해제",
  "unnamed": "이름 없음",
  "unpinConversation": "대화 고정 해제",
  "unplan": "미계획으로 전환",
  "unplanAnalysis": "분석 미계획으로 전환",
  "unplanItemType": "{{itemType}} 미계획으로 전환",
  "unplanSample": "샘플 미계획으로 전환",
  "unplanSelected": "선택 항목 미계획으로 전환",
  "unplanned": "미계획",
  "unplannedProjects": "미계획 프로젝트",
  "unsavedChangesIn": "저장되지 않은 변경사항:",
  "updateIntegration": "통합 업데이트",
  "updatedIcalOutlook": "iCalendar / Outlook이 업데이트되었습니다!",
  "uploadAborted": "업로드가 중단되었습니다!",
  "uploadComplete": "업로드가 완료되었습니다!",
  "uploadFailedForFile": "파일 업로드 실패: {{path}}",
  "uploadFinished": "업로드 완료!",
  "uploadTo": "{{name}}에 업로드",
  "usage": "사용량",
  "used": "사용됨",
  "usedAssets": "사용된 자산",
  "usedInstrument": "사용된 장비",
  "usedInstruments": "사용된 장비",
  "username": "사용자명",
  "value": "값",
  "view": "보기",
  "viewAllAnalysesForProduct": "이 제품의 모든 분석 보기",
  "viewAnalysisSamples": "분석 샘플 보기",
  "viewCompact": "간결하게 보기",
  "viewNormal": "일반 보기",
  "weekNumber": "{{week}}주차",
  "weekView": "주간 보기",
  "dayView": "일간 보기",
  "weekendView": "주말 보기",
  "screen": "화면",
  "clickToSortBy": "{{column}}별로 정렬하려면 클릭하세요",
  "fileChangedPleaseReselect": "{{file}}이(가) 변경되었습니다. 파일을 다시 선택하세요",
  "contentTooWideZoomOut": "화면에 비해 콘텐츠가 너무 넓습니다. 더 나은 보기 환경을 위해 축소하세요 ({{key}} +/-)",
  "week": "주",
  "weekly": "매주",
  "weeks": "주",
  "withConnections": "연결 포함",
  "workHours": "근무 시간",
  "workWeek": "근무 주간",
  "years": "년",
  "yes": "예",
  "youAreInSimulationMode": "시뮬레이션 모드입니다",
  "zeroHours": "0시간",
  "addCustomer": "고객 추가",
  "addGlobalChatbot": "글로벌 챗봇 추가",
  "addGlobalRepository": "글로벌 저장소 추가",
  "apiKey": "API 키",
  "authenticationCode": "인증 코드",
  "authenticationCodeSentInfo": "인증 코드가 이메일로 전송되었습니다. 로그인 전에 위에 입력하세요",
  "chatbotPrefix": "챗봇 접두사",
  "chatbotSystemPrompt": "챗봇 시스템 프롬프트",
  "chatbotSystemPrompts": "챗봇 시스템 프롬프트",
  "citationGuidelines": "인용 지침",
  "configureMember": "멤버 구성",
  "createApiKey": "API 키 생성",
  "creatingProject": "프로젝트 생성 중",
  "currentQuestion": "현재 질문",
  "customerAdminApiKeyForGlobalRepositories": "글로벌 저장소용 고객 관리자 API 키",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "API 키 삭제",
  "descriptionPrompt": "설명 프롬프트",
  "editGlobalMessage": "글로벌 메시지 편집",
  "editingProject": "프로젝트 편집 중",
  "editSystemPrompts": "시스템 프롬프트 편집",
  "filePathPrompt": "파일 경로 프롬프트",
  "fillingInSamples": "샘플 채우는 중",
  "generalPrefix": "일반 접두사",
  "globalChatbots": "글로벌 챗봇",
  "globalRepositories": "글로벌 저장소",
  "hideNextWeek": "다음 주 숨기기",
  "hideSatSun": "- 토/일",
  "manageAdmins": "관리자 관리",
  "oneWeek": "1주",
  "openMetricsPanel": "지표/IAP 패널 열기",
  "openTodoList": "할 일 목록 열기",
  "optimizedQuestionPrompt": "최적화된 질문 프롬프트",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plannertech 팀 계획",
  "previousConversation": "이전 대화",
  "librarianLogoAlt": "라이브러리안 로고",
  "qcLibrarianForCompany": "{{company}} QC 라이브러리안",
  "relevantDocumentation": "관련 문서",
  "repositoryHasUnprocessedFilesInfo": "이 저장소에 처리되지 않은 파일이 있습니다",
  "repositoryIsEmpty": "이 저장소는 비어 있습니다",
  "repositoryPrefix": "저장소 접두사",
  "repositoryProcessingInProgressInfo": "저장소가 현재 파일을 처리 중입니다. 진행 상황을 보려면 페이지를 새로고침하세요",
  "sampleAllocation": "샘플 할당",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "좌석: {{count}}",
  "excludingToday": "오늘 제외",
  "unplanning": "미계획 전환 중",
  "activeSeats": "활성 좌석: {{count}}",
  "totalSeats": "일반 좌석: {{count}}",
  "purchasedSeats": "구매한 좌석: {{count}}",
  "freeSeats": "읽기 전용 좌석: {{count}}",
  "freeSeatsWithCount": "읽기 전용 좌석: {{count}}",
  "viewOnly": "읽기 전용",
  "globalMessage": "글로벌 메시지",
  "clearGlobalMessageConfirm": "글로벌 메시지를 지우시겠습니까? 모든 사용자에게 사라집니다.",
  "samplesCount": "샘플: {{count}}",
  "locations": "위치",
  "customers": "고객",
  "editCustomer": "고객 편집",
  "addCustomerTitle": "고객 추가",
  "deleteCustomer": "고객 삭제",
  "customerName": "고객 이름",
  "customerStatus": "고객 상태",
  "active": "활성",
  "passive": "비활성",
  "allowedDomains": "허용된 도메인",
  "allowedPerformers": "허용된 수행자",
  "seatsPurchased": "구매한 좌석",
  "customerApiKey": "고객 API 키",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "계속",
  "showNextWeek": "다음 주 보기",
  "showSatSun": "+ 토/일",
  "topDescriptionPrompt": "상단 설명 프롬프트",
  "twoWeeks": "2주",
  "updateHelpPage": "도움말 페이지 업데이트",
  "userAlreadyLoggedInTakeOver": "사용자가 이미 로그인되어 있습니다. 세션을 인수하려면 확인을 누르세요",
  "zoomIn": "확대",
  "zoomOut": "축소",
  "constraintWarningTitle": "{{count}}개의 경고가 발생했습니다",
  "assetStatusFree": "여유",
  "assetStatusBooked": "예약됨",
  "dateTo": "까지",
  "futureAnalysisTaskCantBeFinished": "미래 분석 작업은 완료 상태가 될 수 없습니다",
  "tableNotFound": "테이블을 찾을 수 없습니다",
  "conversionSheetFilename": "변환 시트.xlsx",
  "back": "뒤로",
  "selectTeam": "로그인할 팀을 선택하세요",
  "admin": "관리자",
  "customerAdmin": "고객 관리자",
  "attachFile": "파일 첨부",
  "removeFile": "파일 제거",
  "fileTooLarge": "파일이 너무 큽니다 (최대 10 MB)",
  "tooManyFiles": "메시지당 최대 3개 파일",
  "unsupportedFileType": "지원되지 않는 파일 형식입니다. 허용: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
